import { Button, Form, Input, Spin } from 'antd';
import { StyledCheckEnrollmentCodeStep } from './CheckEnrollmentCodeStep.styled';
import useCheckEnrollmentCodeStep from './useCheckEnrollmentCodeStep.hook';

export default function CheckEnrollmentCodeStep({ flowActions }) {
  const [form] = Form.useForm();
  const { state, actions } = useCheckEnrollmentCodeStep({ flowActions, form });
  return (
    <StyledCheckEnrollmentCodeStep>
      <Spin spinning={state.loading && !state.showForm}>
        {state.showForm && (
          <div className="centered-form">
            <Form
              form={form}
              layout="vertical"
              initialValues={{}}
              onFinish={(values) =>
                actions.checkEnrollmentCode(values.enrollmentCode)
              }
              autoComplete="off"
            >
              <Form.Item
                name="enrollmentCode"
                rules={[
                  {
                    required: true,
                    message: 'Please input an enrollment code',
                  },
                ]}
                autoComplete="off"
              >
                <Input size="large" placeholder="Input an enrollment code" />
              </Form.Item>

              <Form.Item>
                <Button
                  htmlType="submit"
                  type="primary"
                  size="large"
                  block
                  loading={state.loading}
                >
                  Continue
                </Button>
              </Form.Item>
            </Form>
          </div>
        )}
      </Spin>
    </StyledCheckEnrollmentCodeStep>
  );
}
